<a
   class="rounded rounded-3 text-decoration-none py-2 px-3 d-flex align-items-center col justify-content-center border border-2 border-third text-third"
   href="{{ kindOfContact }}:{{ contact }}">
   <i class="material-symbols-outlined me-2">
      {{ kindOfContact == 'mailto' ? 'mail' : 'call' }}
   </i>
   {{ contact }}
</a>